// extracted by mini-css-extract-plugin
export default {"container":"UploadPage_container__V9bI-","text":"UploadPage_text__sMueU","separator":"UploadPage_separator__sB9vD","submitButton":"UploadPage_submitButton__Clkcu"};